import { Component, OnInit } from '@angular/core';
import {GlobalDataService, IsAdmin, ResetAuthToken} from '../global-data.service';
import {Customer} from '../app-models/models';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../authentication-service.service';
import {ManageCustomerService} from '../manage-customer.service';

@Component({
  selector: 'app-manage-customer',
  templateUrl: './manage-customer.component.html',
  styleUrls: ['./manage-customer.component.css'],
  providers: [ManageCustomerService]
})
export class ManageCustomerComponent implements OnInit {

  private id: string;
  private compObj: Customer;
  private actionMessage: string;
  private actionStatus = true;
  private isAdmin = false;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ManageCustomerService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.isAdmin = IsAdmin.call(this);
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.route.queryParams
      .subscribe(params => {
        this.id = params['id'];
      });
    this.componentService.getData(this.id).then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.compObj = result;
  }

  mainFail(e) {
      ResetAuthToken.call(this);
  }

  onSubmit() {
    this.actionMessage = null;
    this.componentService.editData(this.compObj).then(this.submitSuccess.bind(this))
      .catch(this.submitFail.bind(this));
  }

  submitFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Save Failed!';
    }
  }

  submitSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

  createSub(event) {
    this.router.navigate(['/create/subscription'], { queryParams: { custId: this.id } });
  }

  editSub(id: string) {
    this.router.navigate(['/manage/subscription'], { queryParams: { id: id } });
  }

  onDelete() {
    this.actionMessage = null;
    this.componentService.deleteItem(this.compObj.id).then(this.deleteSuccess.bind(this))
      .catch(this.deleteFail.bind(this));
  }

  deleteFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Delete Failed!';
    }
  }

  deleteSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

}



// WEBPACK FOOTER //
// ./src/app/manage-customer/manage-customer.component.ts